import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box } from '@mui/material';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';

const ConfirmDeleteDialog = ({ open, title, subtitle, onConfirm, onClose, loading }) => {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogContent sx={{ textAlign: 'center', pt: 4 }}>
                <Box sx={{ mb: 2 }}>
                    <WarningAmberRoundedIcon sx={{ fontSize: 60, color: 'error.main' }} />
                </Box>
                <Typography variant="h5" fontWeight={700} gutterBottom>
                    {title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    {subtitle}
                </Typography>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 3, justifyContent: 'center', gap: 2 }}>
                <Button variant="outlined" onClick={onClose} disabled={loading} fullWidth>
                    Cancel
                </Button>
                <Button variant="contained" color="error" onClick={onConfirm} disabled={loading} fullWidth>
                    {loading ? 'Deleting...' : 'Yes, Delete'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmDeleteDialog;
